import { api } from "@/api/client";
import { toast } from "sonner";

/** "Preview as Agency" — mirrors lib/clientPortalPreview.js's openClientPortalPreview() exactly.
 * Opens the real Agency Portal, as that agency, in a new tab — for staff to check what an
 * agency sees. Read-only and non-destructive to the caller's own staff session: a dedicated
 * `agency_preview_link` token + `njm_agency_preview_access` cookie (never `njm_agency_access`),
 * so this can never sign the staff tab out, and every agency-side write is server-rejected for
 * this session regardless of what the UI shows. Attributed server-side to whichever staff
 * member clicked it. Agency-LEVEL preview (not per-person) — shows the union of everything the
 * agency as a whole is linked to, never narrowed to one specific member's assignments.
 * Safari/Firefox only honor `window.open` synchronously inside the click handler — open a
 * blank tab FIRST, before any await, then redirect it once the mint call resolves.
 * `nextPath` (Recce Wave 2A, 2026-10, RA-13) — optional deep link (must start with
 * "/agency/", e.g. `/agency/projects/{id}?tab=Recce&recce={id}`) so a caller previewing one
 * specific screen lands straight on it instead of the agency home; every existing caller
 * that omits it keeps landing on `/agency?preview=1` exactly as before. */
export async function openAgencyPortalPreview(agencyRemoteId, agencyName, nextPath) {
  if (!window.confirm(`Open the real Agency Portal as "${agencyName}"?\n\nRead-only preview — opens in a new tab, your own staff session stays signed in.`)) {
    return false;
  }
  const tab = window.open("", "_blank");
  if (!tab) {
    toast.error("Your browser blocked the new tab — allow pop-ups for this site and try again.");
    return false;
  }
  try {
    const r = await api.post(`/v1/build/agency/${agencyRemoteId}/preview`, nextPath ? { next: nextPath } : {});
    tab.location.href = `${window.location.origin}/api/v1/build/agency/auth/verify-preview?token=${r.data.token}`;
    toast.success(`Opening as "${agencyName}" — read-only preview`);
    return true;
  } catch (e) {
    tab.close();
    toast.error("Couldn't open the preview — try again.");
    return false;
  }
}
